const topics = [
  { icon: 'ri-user-smile-line', title: '网红爆料专区', desc: '头部主播、短视频达人、微博大V最新黑料合集', count: '326条' },
  { icon: 'ri-star-line', title: '明星八卦速递', desc: '娱乐圈艺人私生活、合约纠纷、片场秘闻全收录', count: '258条' },
  { icon: 'ri-tv-2-line', title: '综艺节目揭秘', desc: '选秀内幕、真人秀剧本外泄、选手真实关系大起底', count: '189条' },
  { icon: 'ri-movie-line', title: '影视剧集扒皮', desc: '热门剧集拍摄事故、演员替换风波、资方博弈揭秘', count: '147条' },
  { icon: 'ri-building-2-line', title: 'MCN机构深挖', desc: '头部机构运营内幕、签约陷阱、博主维权全追踪', count: '112条' },
  { icon: 'ri-robot-2-line', title: 'AI换脸曝光', desc: '深度伪造事件、数字人侵权、AI技术滥用警示专题', count: '95条' },
  { icon: 'ri-fire-line', title: '年度十大黑料', desc: '年度最震撼黑料事件回顾，经典大瓜永久珍藏', count: '精选' },
];

export default function Index() {
  return (
    <section id="index" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-3">
            专题合集
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            按主题分类浏览，快速找到你感兴趣的黑料内容
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 md:gap-5">
          {topics.map((item, i) => (
            <a
              key={i}
              href="#cards"
              onClick={(e) => { e.preventDefault(); document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' }); }}
              className="group flex items-start gap-4 p-5 bg-white rounded-2xl border border-background-200/60 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="w-11 h-11 rounded-xl bg-primary-50 flex items-center justify-center flex-shrink-0 group-hover:bg-primary-100 transition-colors">
                <i className={`${item.icon} text-lg text-primary-600`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center justify-between mb-1">
                  <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                    {item.title}
                  </h3>
                  <span className="text-xs text-foreground-400 bg-background-100 px-2 py-0.5 rounded-full whitespace-nowrap">
                    {item.count}
                  </span>
                </div>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}